import { UIHeading3, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingDecorationBanner {
  title: string;
  description: string;
  callButton: React.ReactElement;
}

export const NewbuildingDecorationBanner = ({ title, description, callButton }: INewbuildingDecorationBanner) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <UIHeading3>Отделка квартиры</UIHeading3>
      </div>
      <div className={styles['banner']}>
        <div className={styles['title']}>
          <UIHeading3>{title}</UIHeading3>
        </div>
        <div className={styles['subtitle']}>
          <UIText1 color="black_60">{description}</UIText1>
        </div>
        <div className={styles['button']}>{callButton}</div>
      </div>
    </div>
  );
};
